import * as React from "react";
import * as AuthStore from "../store/Auth";
import moment from 'moment';
import "../styles/chat.css";
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { fetchData, postQuery } from '../utils';
import { Collapse, Button, message, Row, Col, List, Spin, Select  } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons/lib';
import InfiniteScroll from 'react-infinite-scroll-component';
import { v4 as uuidv4 } from 'uuid';
import * as signalR from '@microsoft/signalr';
// import { busyGif } from '../img';
// import img from "../images/user-icon-1.png";
const { Panel } = Collapse;
const { Option } = Select;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class AppMessaging extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        states: [],
        sites: [],
        statesLoaded: false,
        facilities: [],
        messagingFacilities: [],
        data: [],
        loading: false,
        loadingOth: false,
        confirmLoading: false,
        site: { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        state: { id: 0, name: '', code: '', sites: [], stateId: 0 },
        searchObj:
        {
            state: '',
            site: 0,
            siteName: '',
            stateName: ''
        },
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 100
        },
        msg:
        {
            id: 0,
            messageDate: '',
            messageBody: '',
            messageDateStr: '',
            pepfarId: '',
            facilityName: '',
            datim: '',
            patientId: 0,
            serviceProviderId: 0,
            readByProvider: false,
            sentByPatient: false,
            readByPatient: false,
            uuId: '',
            facilityId: 0
        },
        // loading: false,
        loadingMsg: false,
        hasMore: false,
        facility:
        {
            datim: '',
            facilityId: 0,
            facilityName: '',
            clients: []
        },
        client:
        {
            datim: '',
            patientId: 0,
            pepfarId: '',
            facilityId: 0,
            messages: [],
            unReadMessages: 0,
            pageNumber: 1,
            lastDaysOfRefill: '',
            viralLoadResultDate: '',
            sampleCollectionDate: '',
            lastDrugPickup: '',
            artStartDate: '',
            sex: '',
            phoneNumber: '',
            viralLoad: '',
            currentRegimen: '',
            currentRegimenLine: ''
        },
        signalR: { isInit: false, realtime: {} },
        ids: [],
        sm: ''
    };

    //async getData()
    //{
    //    const { msg } = this.state;
    //    let url = '/api/Stats/';       
    //    this.setState({ loading: true });
    //    let data = await postQuery(url, JSON.stringify(message));        
    //    this.setState({ loading: false });
    //    this.setState({ data });        
    //}

    getDateTime(d: Date)
    {        
        var hours = ((d.getHours() + 11) % 12 + 1);
        var dformat = [(d.getMonth() + 1).toString().padStart(2, '0'),
        d.getDate().toString().padStart(2, '0'),
        d.getFullYear().toString().padStart(4, '0')].join('-') + ' ' +
            [hours.toString().padStart(2, '0'),
                d.getMinutes().toString().padStart(2, '0')].join(':');

        var amPm = d.getHours() > 12? "PM" : "AM";

        return dformat + " " + amPm;
    }

    getDateTime2(d: Date)
    {
        var hours = ((d.getHours() + 11) % 12 + 1);
        var dformat = [(d.getMonth() + 1).toString().padStart(2, '0'),
        d.getDate().toString().padStart(2, '0'),
        d.getFullYear().toString().padStart(4, '0')].join('-') + ' ' +
            [hours.toString().padStart(2, '0'),
            d.getMinutes().toString().padStart(2, '0'), d.getSeconds().toString().padStart(2, '0')].join(':');
        return dformat;
    }

    async componentDidMount()
    {
        let el = this;
        let user = this.props.appUser;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        if (user.stateCode && user.stateCode.length > 0) {
            var statex = states.filter(s => {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0) {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
        el.getInAppMessages();
    }


    async getInAppMessages()
    {
        let el = this;        
        let user = el.props.appUser;   
        var query = `/api/Jolly95/getMessagingFacilities?stateId=${el.state.state.stateId}`;
        this.setState({ loading: true });
        let res = await fetchData(query);
        this.setState({ facilities: res, loading: false });
        await this.initRealtime().then((rtm : any) =>
        {
            if (rtm.code > 0)
            {
                el.setState({ signalR: { isInit: true, realtime: rtm.realtime} });
            }

        });
    }

    async initRealtime()
    {
        let el = this;
        return new Promise((resolve, reject) =>
        {
            let user = el.props.appUser;
            //initiate sigalR
            let connection = new signalR.HubConnectionBuilder()
                .withUrl('/r')
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.None)
                .build();

            connection.on("msgs-" + user.phoneNumber, (msgx) => { //'08070921345' //user.phoneNumber
                if (msgx && msgx.length > 0) {
                    let client = el.state.client;
                    var msgs = client.messages;
                    var gs = [];
                    msgx.map(ms => {
                        var tx = msgs.filter(r => r.uuId === ms.uuId);
                        if (tx.length < 1) {
                            if (ms.sentByPatient === true) {
                                ms.sentByPatient = 'true';
                            }
                            ms.synced = 'true';
                            gs.push(ms);
                        }
                    });
                    var mms = msgs.concat(gs);
                    client.messages = mms;
                    el.setState({ client });
                }
            });

            connection.on(user.phoneNumber, async (ms) => //'08070921345' //user.phoneNumber
            {
                let client = el.state.client;
                var msgs = client.messages;

                if (ms && ms.uuId.length > 0) {
                    ms.messageDateStr = el.getDateTime(new Date(ms.messageDate));
                    ms.synced = 'true';
                    msgs.push(ms);
                    client.messages = msgs;
                    el.setState({ client });

                    var ack = { pepfarId: client.pepfarId, datim: client.datim, providerPhone: user.phoneNumber, uuId: ms.uuId, sentByPatient: false }; //'08070921345'

                    if (el.state.signalR.isInit)
                    {
                        try
                        {
                            el.setState({ loadingMsg: true });
                            ///@ts-ignore
                            await el.state.signalR.realtime.send('rd', ack);
                            el.setState({ loadingMsg: false });
                        }
                        catch (e) {
                            message.error('An error was encountered while processing a background task. Please contact an Administrator.');
                        }
                    }
                    else {
                        message.error('Realtime communication is not ready. Please refresh the page.');
                    }
                }
            });

            connection.start()
                .then(() => {
                    resolve({ code: 5, realtime: connection });
                }).catch(err => {
                    var msg = 'Error: CM16\nIt seems the server cannot be reached.';
                    message.error(msg);
                    console.log(err);
                    reject({code: 0, realtime: null});
                });
        });
    }

    reset()
    {           
        this.setState({
            msg:
            {
                id: 0,
                messageDate: '',
                messageBody: '',
                messageDateStr: '',
                pepfarId: '',
                facilityName: '',
                datim: '',
                patientId: 0,
                serviceProviderId: 0,
                readByProvider: false,
                sentByPatient: false,
                readByPatient: false,
                uuId: '',
                facilityId: 0
            },
            sm: ''
        });
    }

    async showMessage(m, facilityId)
    {
        m.facilityId = facilityId;
        if (m.pageNumber === undefined || m.pageNumber === null)
            m.pageNumber = 1
        let el = this;
        el.setState({ loadingMsg: true, client: m  });
        let res = await postQuery(`/api/Jolly95/getMessages?patientId=${m.patientId}&pageNumber=${m.pageNumber}&itemsPerPage=${20}`, JSON.stringify([]));
        el.setState({ loadingMsg: false });        
        if (res.length > 0)
        {
            let { client } = el.state;
            var msgs = client.messages.concat(res);
            client.messages = msgs;            
            var ids = [];
            res.map(i =>
            {
                if (i.sentByPatient == true && i.readByProvider == false)
                {
                    ids.push(i.id);
                }                
            });   
            var unr = client.unReadMessages - ids.length;
            client.unReadMessages = unr;
            this.setState({ client, hasMore: true, ids: ids });
            el.getMoreMessages(el.state.client);
        }
    }

    async getMoreMessages(client)
    {
        let el = this;
        client.pageNumber += 1;        
        el.setState({ loadingMsg: true });    
        let res = await postQuery(`/api/Jolly95/getMessages?patientId=${client.patientId}&pageNumber=${client.pageNumber}&itemsPerPage=${20}`, JSON.stringify(el.state.ids));        
        el.setState({ loadingMsg: false });    
        
        if (res.length > 0)
        {
            let { client } = el.state;
            var msgs = client.messages.concat(res);
            client.messages = msgs;
            var ids = [];
            res.map(i =>
            {
                if (i.sentByPatient == true && i.readByProvider == false)
                {
                    ids.push(i.id);
                }
            });
            var unr = client.unReadMessages - ids.length;
            client.unReadMessages = unr;
            this.setState({ client, hasMore: true, ids: ids });            
            el.getMoreMessages(client);
        }
        else
        {
            el.setState({ hasMore: false, ids: [] });
        }
    }
   
    async sendMessage()
    {
        let el = this;
        let user = el.props.appUser;
        const { msg } = el.state;                
        if (el.state.sm.length < 1)
        {
            message.error("Please provide a Message");
            return;
        }

        var dm = moment().utc(true);
        var uid = uuidv4();
        msg.patientId = el.state.client.patientId;   
        msg.facilityId = el.state.client.facilityId;  
        msg.pepfarId = el.state.client.pepfarId; 
        msg.datim = el.state.client.datim;
        msg.messageDateStr = dm.format("yyyy-MM-DD hh:mm A");
        msg.messageDate = dm.format("yyyy-MM-DD hh:mm:ss");
        msg.uuId = uid;
        var ms =
        {
            patientId: el.state.client.patientId, pepfarId: el.state.client.pepfarId, datim: el.state.client.datim, serviceProviderId: user.serviceProviderId || 1, messageBody: el.state.sm, messageDateStr: dm.format("yyyy-MM-DD hh:mm A"),
            messageDate: dm, facilityId: el.state.client.facilityId, providerPhone: user.phoneNumber, readByProvider: true, sentByPatient: false, uuId: uid //|| '08070921345'
        };

        if (el.state.signalR.isInit) 
        {
            try
            {
                el.setState({ loadingMsg: true });
                ///@ts-ignore
                el.state.signalR.realtime.send('m', ms);
                el.setState({ loadingMsg: false });
                var client = el.state.client;
                client.messages.push(msg);
                el.setState({ client });
                el.reset();
            }
            catch (e)
            {
                message.error('An error was encountered while processing your message. Please contact an Administrator.');
            }
        }
        else
        {
            try
            {
                await el.initRealtime().then(async (rtm :  any) =>
                {
                    if (rtm.code > 0)
                    {                        
                        el.setState({ loadingMsg: true, signalR: { isInit: true, realtime: rtm.realtime } });
                        console.log(el.state.signalR.realtime);
                        ///@ts-ignore
                        await el.state.signalR.realtime.send('m', ms);
                        el.setState({ loadingMsg: false });
                        var client = el.state.client;
                        client.messages.push(msg);
                        el.setState({ client });
                        el.reset();
                    }
                }); 
            }
            catch (e)
            {
               message.error('Realtime communication is not ready. Please contact an Administrator.');
            }
        }        
    }

    textChange(feture: any, e: any)
    {
        let msg = this.state.msg;   
        var cht = e.target.value;
        msg[feture] = cht;        
        this.setState({ msg, sm: cht});
    }

    keyUpDesc(e)
    {
        let el = this;
        if (e.keyCode === 13)
        {
            let { sm } = el.state;
            sm += '\n';
            el.setState({ sm });
        }        
    }

    selectSite(value: any) {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.siteId === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj, sites });
        }
    }

    selectState(value: any) {
        var el = this;
        if (!value) {
            return;
        }
        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value) {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }

    getMessages() {
        console.log("Here");
    }

    render() 
    {
        const { facilities, client, facility, msg, loading, loadingMsg, hasMore, state, states} = this.state;
        let user = this.props.appUser;
        let el = this;
        
        return (
            <div style={{marginTop: '15px', padding: '20px'}}>
                <Helmet>
                    <title>CDR :: App Messaging</title>
                </Helmet>    
                <div className="custom-filter-dropdown">                         
                    <Row>
                        <div id="container" style={{ borderWidth: '2', borderColor: '#000000', width: '100%' }}>
                            <Row style={{ marginTop: '2px' }}>
                                <Col span={24} style={{ padding: '10px'}}>
                                    <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>App Messaging</h4>
                                </Col>
                            </Row>
                            <br />
                            <aside style={{ overflowY: 'auto', width: '30%' }}>

                                <header>
                                <Row>                                        
                                    {!user.stateCode &&
                                        <Col span={24}>
                                            <Select
                                                labelInValue className="top-10-margin"
                                                showSearch
                                                optionFilterProp="children"
                                                disabled={loading}
                                                style={{ width: '98%' }}
                                                placeholder="Select State"
                                                onChange={(value) => this.selectState(value)}
                                            >
                                                <Option key="" value="">-- Select State --</Option>
                                                {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                            </Select>
                                        </Col>
                                    }
                                    <Col span={24}>
                                        <Select
                                            labelInValue className="top-10-margin"
                                            showSearch
                                            optionFilterProp="children"
                                            disabled={loading}
                                            style={{ width: '98%' }}
                                            placeholder="Select Facility"
                                            onChange={(value) => this.selectSite(value)}
                                        >
                                            <Option key="" value="">-- Select Facility --</Option>
                                            {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                        </Select>
                                    </Col>
                                    <Col span={24}>
                                        <Button disabled={loading} className="login-button top-10-margin" id="push-btn" loading={loading} key="submit" type="primary" size="large" onClick={() => this.getInAppMessages()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width: '100%' }}>
                                            <span id="buttonText">Filter</span>
                                        </Button>
                                    </Col>
                                </Row>
                                </header>

                                {/*<Card className="ant-card-body pfs s-list" loading={loading}>*/}
                                    <Collapse bordered={false} expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />} className="site-collapse-custom-collapse" >
                                        {facilities && facilities.map(j => <Panel header={j.facilityName} key={j.datim} className="site-collapse-custom-panel">
                                            <Row style={{ marginBottom: '8px' }}>
                                                <Col span={24}>
                                                    <ul className='mcd'>
                                                        {j.clients && j.clients.map(m => <li key={m.pepfarId } style={{ cursor: 'pointer' }} onClick={() => el.showMessage(m, j.facilityId)}>
                                                            <img src="../images/user-icon-1.png" alt="" />
                                                            <div>
                                                                <h2>{m.pepfarId}</h2>
                                                                <h3>
                                                                    {m.unReadMessages > 0 ? <p> unread :  <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ff725d' }}>&nbsp;     ({m.unReadMessages})</span></p> : ''}
                                                                </h3>
                                                            </div>
                                                        </li>)}
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </Panel>)}
                                    </Collapse>    
                                {/*</Card>*/}         
                            </aside>
                            {client.pepfarId.length > 0 && <div className="main" style={{ width: '70%' }}>
                                <div className='ant-row'>
                                    <div className="ant-col-4">
                                        <img src="../images/user-icon-1.png" alt="" className="prof-img"/>
                                    </div>
                                    <div className="ant-col-20">
                                        <div className="ant-row">
                                            <div className='ant-col-8 padding-md'>
                                              Unique ID: <h6>{client.pepfarId}</h6>
                                            </div>
                                            <div className='ant-col-8 padding-md'>
                                                Phone Number: <h6>{client.phoneNumber}</h6>
                                            </div>
                                        </div>
                                        <div className="ant-row">
                                            <div className='ant-col-8 padding-md'>
                                                ART Start Date: <h6>{client.artStartDate}</h6>
                                            </div>
                                            <div className='ant-col-8 padding-md'>
                                                Sex: <h6>{(client.sex && client.sex.length > 0 && client.sex === 'M')? 'Male' : 'Female'}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <InfiniteScroll style={{backgroundColor: '#fff'}}
                                    dataLength={client.messages.length}
                                    loader={<div className="scroll-container">
                                        <Spin />
                                    </div>}
                                    next={() => el.getMoreMessages(client)}
                                    hasMore={!loadingMsg && hasMore}
                                >
                                    <List
                                        dataSource={client.messages}
                                        renderItem={m => (
                                            <List.Item key={m.uuId} className={(m.sentByPatient || m.sentByPatient === true) ? "you" : "me"}>
                                                <div className="entete">
                                                    <h3>{m.messageDateStr}</h3>
                                                </div>
                                                {(m.sentByPatient || m.sentByPatient === true) && <div className="triangle"></div>}
                                                <div className="message">
                                                    {m.messageBody}
                                                </div>
                                                {(!m.sentByPatient || m.sentByPatient === false) && <div className="triangle"></div>}
                                            </List.Item>
                                        )}
                                    >
                                    </List>
                                </InfiniteScroll>
                                <footer>
                                    <Row>
                                        <Col span={20}>
                                            <textarea id='txt-msg' onKeyUp={e => this.keyUpDesc(e)} placeholder="Type your message" onChange={(e) => this.textChange('messageBody', e)} value={msg.messageBody} ></textarea>
                                        </Col>
                                        <Col span={4}>
                                            <Button type="primary" className="btnd" onClick={() => el.sendMessage()} style={{ bottom: 0 }}> Send </Button>
                                        </Col>
                                    </Row>
                                </footer>
                            </div>}                       
                        </div>
                    </Row>
                    <br />
                    <br />
                </div>                            
            </div>
        ) 
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(AppMessaging as any);

